/* KRYØS — product configurator (real variants + add-on line items) */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s), $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const fmt = (cents) => (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';

  function initConfigurator(root) {
    if (root.dataset.cfg) return; root.dataset.cfg = '1';
    const variants = JSON.parse($('script[data-variants]', root).textContent);
    const sel = JSON.parse(root.dataset.selected || '[]');
    const form = $('form.ky-buy-form', root), idInput = $('input[name="id"]', form);
    const totalEl = $('[data-total]', root), btn = $('[data-add]', root), qtyIn = $('[data-qty]', root), stockEl = $('[data-stock]', root);
    const cv = $('canvas[data-lure3d]', root);
    let extras = {}; // group -> {id, price}
    let qty = 1;

    const current = () => variants.find((v) => v.opts.every((o, i) => o === sel[i])) || null;

    function refresh(pulse) {
      const v = current();
      const extraSum = Object.values(extras).reduce((a, e) => a + e.price, 0);
      // option availability
      $$('[data-opt-idx]', root).forEach((b) => {
        const i = +b.dataset.optIdx, val = b.dataset.value;
        const test = sel.slice(); test[i] = val;
        const vv = variants.find((x) => x.opts.every((o, k) => o === test[k]));
        b.classList.toggle('off', !vv || !vv.avail);
        b.classList.toggle('active', sel[i] === val);
      });
      if (!v) { btn.disabled = true; btn.querySelector('span').textContent = 'Combinaison indisponible'; return; }
      idInput.value = v.id;
      const maxQ = v.inv === null ? 99 : Math.max(0, v.inv);
      if (qty > maxQ && maxQ > 0) qty = maxQ;
      qtyIn.value = qty; qtyIn.max = maxQ;
      const total = (v.price + extraSum) * qty;
      if (totalEl) { totalEl.textContent = fmt(total); if (pulse && window.gsap) gsap.fromTo(totalEl, { y: -8, opacity: 0.3 }, { y: 0, opacity: 1, duration: 0.5, ease: 'power3.out' }); }
      if (stockEl) {
        if (!v.avail) { stockEl.textContent = '● ÉPUISÉ'; stockEl.className = 'stock out'; }
        else if (v.inv !== null && v.inv <= 12) { stockEl.textContent = '● ' + v.inv + ' RESTANT' + (v.inv > 1 ? 'S' : '') + ' — COLORIS SÉLECTIONNÉ'; stockEl.className = 'stock low'; }
        else { stockEl.textContent = v.inv === null ? '● DISPONIBLE' : '● EN STOCK'; stockEl.className = 'stock'; }
      }
      const soldOut = !v.avail;
      btn.dataset.soldout = soldOut ? '1' : '';
      btn.querySelector('span').textContent = soldOut ? 'Épuisé — Rejoindre la liste' : 'Ajouter au panier';
      // 3D colour
      const swatch = $('[data-opt-idx][data-hex].active', root);
      if (swatch && cv && cv._lure && pulse) { cv._lure.setColor(swatch.dataset.hex); cv._lure.pulse(); }
      // price display main
      const pm = $('[data-price-main]', root); if (pm) pm.textContent = fmt(v.price);
      const sp = $('[data-sticky-price]'); if (sp) sp.textContent = fmt(total);
      const sb = $('[data-sticky-add] span'); if (sb) sb.textContent = soldOut ? 'Épuisé' : 'Ajouter au panier';
      // update URL variant param
      try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }

    $$('[data-opt-idx]', root).forEach((b) => b.addEventListener('click', () => {
      sel[+b.dataset.optIdx] = b.dataset.value; refresh(true);
      if (b.dataset.tex) {
        const cvs = document.getElementById('pdpLure');
        if (cvs) { cvs.dataset.tex = b.dataset.tex; cvs.dataset.depth = b.dataset.depth; cvs.dataset.thick = b.dataset.thick; }
        cvs && cvs._lure && cvs._lure.load && cvs._lure.load(b.dataset.tex, b.dataset.depth, parseFloat(b.dataset.thick));
        document.dispatchEvent(new CustomEvent('ky:model', { detail: { tex: b.dataset.tex } }));
      }
    }));
    $$('[data-extra-group]', root).forEach((b) => b.addEventListener('click', () => {
      const g = b.dataset.extraGroup;
      $$('[data-extra-group="' + g + '"]', root).forEach((x) => x.classList.remove('active')); b.classList.add('active');
      if (b.dataset.extraId) extras[g] = { id: +b.dataset.extraId, price: +b.dataset.extraPrice, title: b.dataset.extraTitle }; else delete extras[g];
      refresh(true);
    }));
    $('[data-q-minus]', root)?.addEventListener('click', () => { qty = Math.max(1, qty - 1); refresh(true); });
    $('[data-q-plus]', root)?.addEventListener('click', () => { const v = current(); const m = v && v.inv !== null ? v.inv : 99; if (qty < m) qty++; else window.toast && toast('Stock maximum atteint pour ce coloris'); refresh(true); });
    qtyIn?.addEventListener('change', () => { qty = Math.max(1, parseInt(qtyIn.value) || 1); refresh(true); });

    form.addEventListener('submit', async (e) => {
      const v = current(); if (!v) { e.preventDefault(); return; }
      if (btn.dataset.soldout) { e.preventDefault(); $('[data-open-modal]', root)?.click(); return; }
      if (!window.KY || !KY.addToCart) return; // native fallback
      e.preventDefault();
      const props = {};
      const cfgId = 'KRY-' + Math.random().toString(36).slice(2, 7).toUpperCase();
      Object.entries(extras).forEach(([g, x]) => (props[g] = x.title));
      const items = [{ id: v.id, quantity: qty, properties: Object.keys(props).length ? Object.assign({}, props, { _config: cfgId }) : undefined }];
      Object.values(extras).forEach((x) => items.push({ id: x.id, quantity: qty, properties: { _config: cfgId } }));
      const label = btn.querySelector('span'), old = label.textContent;
      btn.disabled = true; label.textContent = 'Ajout…';
      try { await KY.addToCart(items); label.textContent = '✓ Ajouté'; }
      catch (er) { window.toast && toast(er.message); label.textContent = old; }
      setTimeout(() => { btn.disabled = false; refresh(false); }, 1600);
    });
    // Barre d'achat collante (mobile) : visible seulement quand le vrai bouton est hors de l'écran.
    const sticky = $('[data-sticky-buy]', root), buyRow = $('.buy-row', root);
    if (sticky && buyRow && 'IntersectionObserver' in window) {
      document.body.appendChild(sticky);
      $('[data-sticky-add]', sticky).addEventListener('click', () => {
        if (btn.dataset.soldout) { buyRow.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        form.requestSubmit ? form.requestSubmit(btn) : btn.click();
      });
      new IntersectionObserver(([e]) => {
        const on = !e.isIntersecting;
        sticky.classList.toggle('on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        $('[data-sticky-add]', sticky).tabIndex = on ? 0 : -1;
      }).observe(buyRow);
    }
    refresh(false);
  }
  function boot() { $$('[data-configurator]').forEach(initConfigurator); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
